document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initComparador();
  initContador();
  initGaleriaProducto();
  initVariantesProducto();
  initPuenteCarritoApps();
});

// Apps externas (ej. Releasit Bundle) agregan varios artículos al carrito con su
// propio botón, sin avisarle al tema — el cliente no ve confirmación ni forma de
// pagar. Detectamos esas llamadas a /cart/add y, cuando agregan más de un
// artículo a la vez (típico de una oferta de combo), llevamos al cliente al
// carrito real para que pueda continuar y pagar.
function initPuenteCarritoApps() {
  const fetchOriginal = window.fetch;
  if (!fetchOriginal || fetchOriginal.__mtWrapped) return;

  window.fetch = function (...args) {
    const promesa = fetchOriginal.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) return promesa;

    promesa
      .then((res) => res.clone().json())
      .then((data) => {
        if (data && Array.isArray(data.items) && data.items.length > 1) {
          window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart'
            : '/cart';
        }
      })
      .catch(() => {});

    return promesa;
  };
  window.fetch.__mtWrapped = true;
}

function initGaleriaProducto() {
  const principal = document.getElementById('mt-prod-imagen-principal');
  const minis = document.querySelectorAll('[data-mt-mini]');
  if (!principal || !minis.length) return;
  const lista = Array.from(minis);
  let actual = Math.max(0, lista.findIndex((b) => b.getAttribute('data-full') === principal.src));
  let pausaHasta = 0;
  let encima = false;

  const video = document.getElementById('mt-prod-video');
  function mostrarVideo(btn) {
    if (!video) return false;
    const v = btn.getAttribute('data-video');
    if (!v) { video.pause(); video.hidden = true; principal.hidden = false; return false; }
    principal.hidden = true;
    video.hidden = false;
    video.poster = btn.getAttribute('data-full');
    if (video.getAttribute('src') !== v) video.src = v;
    const p = video.play();
    if (p && p.catch) p.catch(() => {});
    pausaHasta = Date.now() + 3600000; // mientras se ve el video, la galería no avanza sola
    return true;
  }

  function mostrar(i) {
    actual = (i + lista.length) % lista.length;
    const btn = lista[actual];
    lista.forEach((b) => b.classList.toggle('mt-activo', b === btn));
    if (mostrarVideo(btn)) return;
    const url = btn.getAttribute('data-full');
    const siguiente = new Image();
    siguiente.onload = () => {
      principal.classList.add('mt-cambiando');
      setTimeout(() => {
        principal.src = url;
        principal.classList.remove('mt-cambiando');
      }, 180);
    };
    siguiente.src = url;
  }

  lista.forEach((btn, i) => {
    btn.addEventListener('click', () => {
      pausaHasta = Date.now() + 8000;
      mostrar(i);
    });
  });
  lista[actual].classList.add('mt-activo');
  mostrarVideo(lista[actual]); // si la primera foto es un video, arranca reproduciéndose

  // Cambio automático: la galería avanza sola y se detiene mientras el cliente la usa.
  const galeria = document.querySelector('[data-mt-galeria-auto]');
  if (!galeria) return;
  const segundos = Math.max(2, parseInt(galeria.getAttribute('data-mt-galeria-auto'), 10) || 3);
  window.addEventListener('load', () => lista.forEach((b) => { new Image().src = b.getAttribute('data-full'); }));
  galeria.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') encima = true; });
  galeria.addEventListener('pointerleave', () => { encima = false; });
  galeria.addEventListener('touchstart', () => { pausaHasta = Date.now() + 8000; }, { passive: true });
  setInterval(() => {
    if (encima || document.hidden || Date.now() < pausaHasta) return;
    mostrar(actual + 1);
  }, segundos * 1000);
}

function initVariantesProducto() {
  const form = document.getElementById('mt-form-producto');
  if (!form) return;
  const jsonEl = document.getElementById('mt-variantes-json');
  const idInput = document.getElementById('mt-variant-id');
  const grupos = document.querySelectorAll('[data-mt-opcion-index]');
  const btnComprar = form.querySelector('.mt-prod-btn-comprar');
  const precioEl = document.querySelector('.mt-prod-precio');
  if (!jsonEl || !grupos.length) return;

  let variantes;
  try {
    variantes = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }

  function seleccionActual() {
    return Array.from(grupos).map((g) => {
      const activo = g.querySelector('.mt-prod-opcion-btn.mt-activo');
      return activo ? activo.getAttribute('data-valor') : null;
    });
  }

  function actualizar() {
    const sel = seleccionActual();
    const variante = variantes.find((v) => {
      const opciones = [v.option1, v.option2, v.option3].filter((o) => o !== null && o !== undefined);
      return sel.every((val, i) => val === null || opciones[i] === val);
    });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl && variante.price) {
      const num = parseFloat(variante.price) / 100;
      precioEl.textContent = '$' + num.toLocaleString('es-CO', { minimumFractionDigits: 0 });
    }
    if (btnComprar) {
      btnComprar.disabled = !variante.available;
    }
  }

  grupos.forEach((grupo) => {
    grupo.querySelectorAll('.mt-prod-opcion-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        grupo.querySelectorAll('.mt-prod-opcion-btn').forEach((b) => b.classList.remove('mt-activo'));
        btn.classList.add('mt-activo');
        actualizar();
      });
    });
  });
}

function initReveals() {
  const els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach((el) => io.observe(el));
}

function initComparador() {
  document.querySelectorAll('[data-mt-comparador]').forEach((wrap) => {
    const antes = wrap.querySelector('.mt-comparador-antes');
    const handle = wrap.querySelector('.mt-comparador-handle');
    if (!antes || !handle) return;

    function mover(clientX) {
      const rect = wrap.getBoundingClientRect();
      let pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      antes.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      handle.style.left = pct + '%';
    }

    let arrastrando = false;
    wrap.addEventListener('pointerdown', (e) => { arrastrando = true; mover(e.clientX); });
    window.addEventListener('pointermove', (e) => { if (arrastrando) mover(e.clientX); });
    window.addEventListener('pointerup', () => { arrastrando = false; });
    wrap.addEventListener('touchstart', (e) => mover(e.touches[0].clientX), { passive: true });
    wrap.addEventListener('touchmove', (e) => mover(e.touches[0].clientX), { passive: true });
  });
}

function initContador() {
  const els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        io.unobserve(el);
        const fin = parseInt(el.getAttribute('data-mt-contador'), 10) || 0;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          el.textContent = fin.toLocaleString('es-CO');
          return;
        }
        const dur = 1400;
        const inicio = performance.now();
        function paso(ahora) {
          const t = Math.min(1, (ahora - inicio) / dur);
          const val = Math.floor(t * fin);
          el.textContent = val.toLocaleString('es-CO');
          if (t < 1) requestAnimationFrame(paso);
          else el.textContent = fin.toLocaleString('es-CO');
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach((el) => io.observe(el));
}
